<script>
import { h } from 'vue'
export default {
  props: {
    nodes: {
      type: Array,
      required: true
    },
    internalSceneClass: {
      type: String,
      default: 'flex'
    }
  },
  render () {
    const modifiedNodes = this.nodes.map((n) => {
      return h('div', { class: this.internalSceneClass }, [n])
    })
    return h('div', { class: 'asfd' }, modifiedNodes)
  }
}
</script>

<style>

</style>
